"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AppContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _toolkit = require("@reduxjs/toolkit");

var _reactRedux = require("react-redux");

var _styles = require("@material-ui/core/styles");

var _pickers = require("@material-ui/pickers");

var _dateFns = _interopRequireDefault(require("@date-io/date-fns"));

var _reactRouterDom = require("react-router-dom");

var _notistack = require("notistack");

var _authProvider = _interopRequireDefault(require("../_common/authProvider"));

var _locator = _interopRequireDefault(require("../locator"));

var _mobileLandscapeMessage = _interopRequireDefault(require("../mobileLandscapeMessage"));

var _ieOverlay = _interopRequireDefault(require("../ieOverlay"));

var _admin = _interopRequireDefault(require("../admin"));

var _theme = _interopRequireDefault(require("../theme"));

var _api = _interopRequireDefault(require("../../api"));

var _AnalyticsTracker = _interopRequireDefault(require("../../api/AnalyticsTracker"));

var _redux = _interopRequireDefault(require("../../redux"));

var _actions = require("../../redux/login/actions");

require("./index.css");

require("@devsontap/dot-react-common/core/css/atomic.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var tracker = new _AnalyticsTracker.default(_api.default);
/**
 * Create a Redux store with Thunk middleware
 */
// const createStoreWithMiddleware = applyMiddleware(reduxThunk.withExtraArgument({api, tracker}))(createStore);
// const store = createStoreWithMiddleware(reducers,
//     process.env.NODE_ENV === "development" &&
//     window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
// );

var AppContext = /*#__PURE__*/_react.default.createContext(null);

exports.AppContext = AppContext;

var NICALocatorCore = function NICALocatorCore(_ref) {
  var themeOptions = _ref.themeOptions,
      images = _ref.images,
      strings = _ref.strings,
      flags = _ref.flags,
      components = _ref.components,
      customTracker = _ref.customTracker,
      children = _ref.children;

  var _useState = (0, _react.useState)(_isInLandscape()),
      _useState2 = _slicedToArray(_useState, 2),
      isInLandscape = _useState2[0],
      setIsInLandscape = _useState2[1];

  (0, _react.useEffect)(function () {
    window.onorientationchange = function () {
      return setIsInLandscape(_isInLandscape());
    };

    store.dispatch((0, _actions.getUserInfo)());
  }, []); // KBM - Create the store here so we can override the tracker with a custom tracker

  var store = (0, _react.useMemo)(function () {
    return (0, _toolkit.configureStore)({
      reducer: _redux.default,
      middleware: function middleware(getDefaultMiddleware) {
        return getDefaultMiddleware({
          thunk: {
            extraArgument: {
              api: _api.default,
              tracker: tracker
            }
          },
          immutableCheck: false,
          serializableCheck: false
        });
      }
    });
  }, []); // KBM -- Redirects for the old Urls
  // TODO: Make sure this ends up in NICA's locator
  // if (document.location.hash.match(/admin|location-manager/i)) {
  //     document.location.href = "https://admin.infusioncenter.org";
  // }

  var content = /*#__PURE__*/_react.default.createElement(_locator.default, null);

  if (isInLandscape) {
    content = /*#__PURE__*/_react.default.createElement(_mobileLandscapeMessage.default, null);
  } else if (_isIE()) {
    content = /*#__PURE__*/_react.default.createElement(_ieOverlay.default, null);
  }

  return /*#__PURE__*/_react.default.createElement(AppContext.Provider, {
    value: {
      images: images,
      strings: strings,
      flags: flags,
      themeOptions: themeOptions,
      components: components
    }
  }, /*#__PURE__*/_react.default.createElement(_notistack.SnackbarProvider, {
    maxSnack: 3
  }, /*#__PURE__*/_react.default.createElement(_styles.MuiThemeProvider, {
    theme: (0, _theme.default)(themeOptions)
  }, /*#__PURE__*/_react.default.createElement(_pickers.MuiPickersUtilsProvider, {
    utils: _dateFns.default
  }, /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
    store: store
  }, /*#__PURE__*/_react.default.createElement(_authProvider.default, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "App"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.BrowserRouter, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/admin/:locationId?/:locationAction?"
  }, /*#__PURE__*/_react.default.createElement(_admin.default, null)), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/:locationId?"
  }, content))), children)))))));
};

function _isInLandscape() {
  return window.orientation != null && (window.orientation === 90 || window.orientation === -90) && window.innerWidth <= 500;
}

function _isIE() {
  var userAgent = window.navigator.userAgent;
  return userAgent.indexOf("MSIE") > -1 || userAgent.indexOf("Trident") > -1;
}

var _default = NICALocatorCore;
exports.default = _default;